import { useQuery } from '@tanstack/react-query';
import QueryKeys from '@constants/queryKeys';
import { MINUTE } from '@constants/various';
import useNotification from '@hooks/useNotification';
import { getWorkerTodos } from '@worker/services/inbox/api';

interface UseWorkerTodosOptions {
  enabled?: boolean;
  showErrorToast?: boolean;
}

export function useWorkerTodos(options?: UseWorkerTodosOptions) {
  const { showErrorNotification } = useNotification();
  const showErrorToast = options?.showErrorToast ?? true;

  return useQuery({
    queryKey: [QueryKeys.WorkerInbox.TODOS],
    queryFn: async () => {
      try {
        return await getWorkerTodos();
      } catch (error) {
        if (showErrorToast) {
          showErrorNotification('Could not load to-do notifications.');
        }
        throw error;
      }
    },
    staleTime: MINUTE,
    retry: false,
    enabled: options?.enabled ?? true,
  });
}
